import { defineComponent as _defineComponent } from 'vue';
import { format, formatDistanceToNow, parseISO } from "date-fns";
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UtcDate',
    props: {
        date: null,
        mode: { default: "date" }
    },
    setup(__props) {
        const props = __props;
        const parsedDate = computed(() => parseISO(`${props.date}Z`));
        const elapsedTime = computed(() => formatDistanceToNow(parsedDate.value, { addSuffix: true }));
        const fullISO = computed(() => parsedDate.value.toISOString());
        const pretty = computed(() => format(parsedDate.value, "eeee MMM do H:mm:ss yyyy zz"));
        return { __sfc: true, props, parsedDate, elapsedTime, fullISO, pretty };
    }
});
